module.exports = __webpack_public_path__ + "img/spw_spacepowergm.6839ad7.png";